<script setup lang="ts">
import Logo from '@/components/Logo.vue';

defineOptions({ name: 'CometNavbar' });

withDefaults(
  defineProps<{
    primary?: boolean;
  }>(),
  { primary: false }
);
</script>

<template>
  <div class="d-flex flex-row align-center justify-space-between">
    <logo :primary="primary"></logo>
    <slot></slot>
  </div>
</template>
